import { z } from 'zod'
import { COMPANY_ROLES } from '../enums/company-role.enum.js'
import { ALL_PERMISSIONS } from '../permissions/role-permissions.js'

const companyMembershipDtoSchema = z.object({
  companyId: z.string().uuid(),
  companyName: z.string(),
  isLender: z.boolean(),
  isOriginator: z.boolean(),
  role: z.enum(COMPANY_ROLES),
})

export type CompanyMembershipDto = z.infer<typeof companyMembershipDtoSchema>

/** The authenticated user shape the API returns and the web app stores. */
export const authUserDtoSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  isPlatformAdmin: z.boolean(),
  /** Personal NMLS (RMLO individuals). */
  nmlsNumber: z.string().nullable(),
  /** Active company for multi-company users; null for platform-only admins. */
  currentCompanyId: z.string().uuid().nullable(),
  memberships: z.array(companyMembershipDtoSchema),
  /**
   * Effective permissions for the current company context (or all for platform
   * admin). Strings are `resource.action`.
   */
  permissions: z.array(z.enum(ALL_PERMISSIONS)),
})

export type AuthUserDto = z.infer<typeof authUserDtoSchema>

/** Response from `POST /auth/login`. */
export const loginResponseDtoSchema = z.object({
  accessToken: z.string(),
  user: authUserDtoSchema,
})

export type LoginResponseDto = z.infer<typeof loginResponseDtoSchema>

/** Acknowledgement for password-reset endpoints (carries no account information). */
export const passwordResetAckDtoSchema = z.object({
  success: z.literal(true),
})

export type PasswordResetAckDto = z.infer<typeof passwordResetAckDtoSchema>
